import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpoints } from "../../constants/endpoints";
import api from "../../services/instance";

export const getProfileReviewsAPI = createAsyncThunk(
    "getProfileReviewsAPI",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.profileReview(payload));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const getSingleProfileAPI = createAsyncThunk(
    "getSingleProfileAPI",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(endpoints.getSingleProfile(id));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

export const UpdateProfileReviewStatusAPI = createAsyncThunk(
    "UpdateProfileReviewStatusAPI",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(endpoints.profileReviewStatus(), data);
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ message: 'Something went wrong' });
        }
    }
)

const initialState = {
    loading: false,
    btnLoading: false,
    profileReview: [],
    singleProfile: "",
    analytics: {
        total: 0,
        professionals: 0,
        corporates: 0,
    },
    pagination: {
        current_page: 1,
        total_pages: 1,
        total: 0,
        per_page: 10,
    }
}

const superAdminProfileReview = createSlice({
    initialState,
    name: "superAdminProfileReview",
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getProfileReviewsAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getProfileReviewsAPI.fulfilled, (state, action) => {
            const profilesData = action.payload.data.data.profiles;
            state.profileReview = profilesData.data;
            state.analytics = action.payload.data.data.analytics;
            state.pagination = {
                current_page: profilesData.current_page,
                total_pages: profilesData.last_page,
                total: profilesData.total,
                per_page: profilesData.per_page,
            };
            state.loading = false;
        });

        builder.addCase(getProfileReviewsAPI.rejected, (state, action) => {
            state.loading = false;
        });

        // GET SINGLE PROFESSIONAL

        builder.addCase(getSingleProfileAPI.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(getSingleProfileAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.singleProfile = action?.payload?.data?.data
        });

        builder.addCase(getSingleProfileAPI.rejected, (state, action) => {
            state.loading = false;
        });

        // ACTIVE PROFILE PAGE

        builder.addCase(UpdateProfileReviewStatusAPI.pending, (state) => {
            state.btnLoading = true;
        });

        builder.addCase(UpdateProfileReviewStatusAPI.fulfilled, (state, action) => {
            state.btnLoading = false;
        });

        builder.addCase(UpdateProfileReviewStatusAPI.rejected, (state, action) => {
            state.btnLoading = false;
        });
    }
});

export const { } = superAdminProfileReview.actions
export default superAdminProfileReview.reducer